export default "/_next/static/images/55/presentation@2x-55accb048b22470a61502946d41768ec.jpg";